import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import ProjectTags from './ProjectTags';
import ProjectActionLink from './ProjectActionLink';
import './Project.css';

const ProjectCard = ({ slug, title, summary, tags = [], liveUrl, sourceUrl, accentColor, image }) => {
  return (
    <div className="project-card">
      
      {image && (<div
        className="project-card__image"
        style={{ backgroundColor: accentColor || '#f0ede8' }}
      >
        {image && (
          <img
            src={image}
            alt={`${title} screenshot`}
            className="project-card__screenshot"
          />
        )}
      </div>)}

      <div className="project-card__body">
        <h3 className="project-card__title">{title}</h3>
        <p className="project-card__description">{summary}</p>

        {slug && <Button as={Link} to={`/projects/${slug}`} className="project-card__button" variant="secondary">
          More
        </Button>}

        {(sourceUrl || liveUrl) && (<div className="project-card__actions">
          {sourceUrl && (
            <ProjectActionLink url={sourceUrl} linkText="Source ↗" />
          )}
          {liveUrl && (
            <ProjectActionLink url={liveUrl} linkText="View live ↗" />
          )}
        </div>)}

        {tags.length > 0 && (
          <div className="project-card__tags">
            <ProjectTags tags={tags} />
          </div>
        )}

      </div>
    </div>
  );
};

export default ProjectCard;
